import { TableLiteShowcase } from 'components'

export const TablesDrawer = () => <TableLiteShowcase />

export default TablesDrawer
